import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import MyContext from "../../../MyContext";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import HtmlEditor from "./HtmlEditorComponents/HtmlEditor";
import { BsBoxArrowUpRight } from "react-icons/bs";
import Select from "react-select";

function CreateBanner() {
  const { baseUrl, config, generatedHTML, setGeneratedHTML } =
    useContext(MyContext);

  const navigate = useNavigate();
  const options = [
    { value: "single-carousel", label: "Single Carousel" },
    { value: "multi-carousel", label: "Multi Carousel" },
  ];

  const [formData, setFormData] = useState({
    cardCount: "",
    title: "",
    status: "Y",
    html: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const createNewBanner = async () => {
    if (!formData.title.trim()) {
      toast.error("Banner title is required");
      return;
    }

    if (!formData.status) {
      toast.error("Status is required");
      return;
    }

    try {
      const res = await axios.post(
        `${baseUrl}/api/Inventory/v2.0/insertCardLayoutGrocery`,
        {
          userid: "A1211",
          cardCount: formData.cardCount,
          html: formData.html,
          title: formData.title,
          status: formData.status,
        },
        config,
      );

      const { responseCode, responseMessage } = res.data || {};

      if (responseCode === "00") {
        toast.success(responseMessage || "Banner created");

        navigate("/Inventory/Banner/banner-library");
      } else {
        toast.error(responseMessage || "Failed");
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  useEffect(() => {
    if (!generatedHTML) return;

    setFormData((prev) => ({
      ...prev,
      html: generatedHTML,
    }));
  }, [generatedHTML]);

  return (
    <div className="d-flex flex-column">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <div className="w-100">
        <div className=" card p-4 shadow-sm w-100 mt-3">

          <div className="mb-3">
            <label className="form-label">Banner Title</label>

            <input
              type="text"
              name="title"
              className="form-control"
              value={formData.title}
              onChange={handleChange}
            />
          </div>


          <div className="mb-3">
            <label className="form-label">Banner Type</label>

            <Select
              options={options}
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  cardType: selected.value,
                }))
              }
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: "#e7e7e7",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#02c27d",
                  },
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isFocused ? "#02c27d" : "white",
                  color: state.isFocused ? "#ffffff" : "black",
                }),
              }}
            />
          </div>

          <div className="mb-4 d-flex align-items-start gap-2 flex-column">
            <label className="form-label mb-0">Status</label>

            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                role="switch"
                name="status"
                checked={formData.status !== "Y"} 
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "status",
                      value: e.target.checked ? "N" : "Y",
                    },
                  })
                }
              />
              <span>{formData.status === "Y" ? "Active" : "Inactive"}</span>
            </div>
          </div>


          <div className="mb-3">
            <div className="d-flex flex-column mb-2">
              <label className="form-label mb-2">Banner HTML</label>
              <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                If you don't have a banner link, open Editor mode to create a
                banner and generate the HTML link.
              </span>
            </div>
            <div>
              <div
                className="banner-html-box overflow-hidden"
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  background: "#f9fafb",
                }}
              >
                <textarea
                  name="html"
                  rows="6"
                  className="banner-html-textarea w-100 p-2"
                  placeholder="Place the code here!"
                  style={{
                    background: "none",
                    border: "none",
                    color: "#3b82f6",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                  value={generatedHTML || formData.html}
                  onChange={handleChange}
                />
                <div
                  className="banner-editor-footer"
                  style={{
                    borderTop: "1px solid #e5e7eb",
                    padding: "8px 12px",
                  }}
                >
                  <button
                    type="button"
                    className="editor-link-btn d-flex allign-items-center gap-1 rounded-2 px-1"
                    style={{
                      background: "#efefef",
                      border: "none",
                      color: "#3b82f6",
                      fontWeight: "500",
                      cursor: "pointer",
                      border: "1px solid lightgrey",
                    }}
                    onClick={() => navigate("/Inventory/Banner/html-editor")}
                  >
                    <BsBoxArrowUpRight />
                    Open Editor mode
                  </button>
                </div>
              </div>
            </div>

            <div className="d-flex gap-2 mt-3">
              <button
                className="inv-btn inv-btn-primary"
                onClick={createNewBanner}
              >
                Create Banner
              </button>

              <button
                className="inv-btn inv-btn-ghost"
                onClick={() => navigate("/Inventory/Banner/create-new-banner")}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateBanner;
